"use strict";

exports.__esModule = true;
exports.sort = void 0;
// String.prototype.localeCompare vs Intl.Collator.compare
// https://stackoverflow.com/a/52369951
var collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base"
});

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return collator.compare(a, b);
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

exports.sort = sort;
//# sourceMappingURL=sort.js.map